<div class="footer-pedido scale-in-ver-center"
     [ngStyle]="{ background: fundo, color: texto }"
     *ngIf="quantidade > 0">
  <div class="left">
    <div class="produtos">{{ quantidade }} {{ quantidade === 1 ? ('cardapio_digital.produto' | translate) : ('cardapio_digital.produtos' | translate) }}</div>
    <div class="total-valor">
      <span>&#x2022; </span>
      <span class="total-valor-numero">{{ formatarPreco(total) }}</span>
    </div>
  </div>
  <div class="right">
    <button pButton
            [label]="'cardapio_digital.ver_pedido' | translate"
            class="p-button-raised button-ver-pedido"
            (click)="verPedido.emit()"></button>
    <button class="btn-limpar-carrinho"
            type="button"
            [attr.aria-label]="'cardapio_digital.limpar_carrinho' | translate"
            (click)="limparCarrinho.emit()">
      <i class="pi pi-trash"></i>
    </button>
  </div>
</div>
